import { render, staticRenderFns } from "./flowInfo.vue?vue&type=template&id=cdf16bc4&"
import script from "./flowInfo.vue?vue&type=script&lang=js&"
export * from "./flowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_uc55t47uxtlogncefk63ylt2rm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports